import { z } from "zod";

/** The aesthetic skin concerns the vision model scores. */
export const skinConcernTypeSchema = z.enum([
	"acne",
	"pigmentation",
	"melasma",
	"pores",
	"wrinkles",
	"dark_circles",
	"redness",
	"texture",
	"other",
]);
export type SkinConcernType = z.infer<typeof skinConcernTypeSchema>;

export const skinAnalysisConcernSchema = z.object({
	type: skinConcernTypeSchema,
	/** 0 (none) … 10 (severe). */
	score: z.number().min(0).max(10),
	/** Estimated count where countable (acne lesions). */
	count: z.number().int().nonnegative().optional(),
	note: z.string().max(400).optional(),
});
export type SkinAnalysisConcern = z.infer<typeof skinAnalysisConcernSchema>;

/** The structured payload the vision model must return. */
export const skinAnalysisResultSchema = z.object({
	concerns: z.array(skinAnalysisConcernSchema).max(20),
	summary: z.string().max(2000),
	caveat: z.string().max(600).optional(),
});
export type SkinAnalysisResult = z.infer<typeof skinAnalysisResultSchema>;

export const skinAnalysisApiSchema = z.object({
	id: z.string().uuid(),
	clinic_id: z.string().uuid(),
	patient_id: z.string().uuid(),
	visit_id: z.string().uuid().nullable(),
	photo_id: z.string().uuid().nullable(),
	concerns: z.array(skinAnalysisConcernSchema),
	summary: z.string().nullable(),
	caveat: z.string().nullable(),
	model_version: z.string().nullable(),
	created_by_member_id: z.string().uuid().nullable(),
	created_by_name: z.string().nullable(),
	created_at: z.string().datetime(),
});
export type SkinAnalysisApi = z.infer<typeof skinAnalysisApiSchema>;

/** Analyze an existing patient photo. */
export const analyzeSkinInputSchema = z.object({
	patient_id: z.string().uuid(),
	visit_id: z.string().uuid().optional(),
	photo_id: z.string().uuid(),
});
export type AnalyzeSkinInput = z.infer<typeof analyzeSkinInputSchema>;
